// extracted by mini-css-extract-plugin
module.exports = {"containerBox":"styles_containerBox__1dBFq"};